import * as moment from 'moment';
import Toolbar from '@/components/toolbar';
import api from '@/utils/api';
import utilityFunctions from '@/utils/functions';
import LoadingComponent from '@/components/loading-component';
import BottomNav from '@/components/bottom-nav';
import HistoryRepeatable from '@/components/service-log/history/history-repeatable/history-repeatable.vue';

export default {
  name: 'SlSearch',
  components: {
    Toolbar,
    LoadingComponent,
    HistoryRepeatable,
    BottomNav
  },
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    },
    isDesktop() {
      return this.$mq === 'laptop' || this.$mq === 'desktop';
    }
  },
  data() {
    return {
      providersArray: null,
      provider: null,
      selectedStudent: null,
      // start date
      serviceMenuStart: false,
      serviceDateStart: null,
      dateStart: null,
      // end date
      serviceMenuEnd: false,
      serviceDateEnd: null,
      dateEnd: null,
      // location
      selectedLocation: null,
      serviceLogsArray: [],
      errorMsg: null,
      showLoading: false,
      pageNumber: 1,
      itemsPerPageArray: [10, 25, 50, 100],
      itemsPerPage: 50,
      loadData: false,
      totalCount: null,
      totalPages: null,
      // service location autocomplete
      locationSearchError: null,
      locationSearchModel: '',
      locationSearchLoading: false,
      locationSearchInput: '',
      locationSearchArray: [],
      // find student autocomplete
      studentSearchError: null,
      studentSearchModel: '',
      studentSearchLoading: false,
      studentSearchInput: '',
      studentSearchArray: [],
      // provider autocomplete
      providerSearchError: '',
      providerSearchModel: '',
      providerSearchInput: null,
      providerSearchLoading: false,
      providerSearchArray: []
    };
  },
  mounted() {
    // if there are stored query params, reexecute that search
    if (this.$route && this.$route.query && !this.isQueryParamsEmpty(this.$route.query)) {
      const query = this.$route.query;
      this.dateStart = query.from ? moment(query.from, 'YYYY-MM-DD').format('MM-DD-YYYY') : '';
      this.dateEnd = query.to ? moment(query.to, 'YYYY-MM-DD').format('MM-DD-YYYY') : '';
      this.providerSearchModel = JSON.parse(localStorage.getItem('provider-search-object')) || '';
      this.studentSearchModel = JSON.parse(localStorage.getItem('student-search-object')) || '';
      this.locationSearchModel = JSON.parse(localStorage.getItem('location-search-object')) || '';
      this.pageNumber = query.pagenumber ? Number(query.pagenumber) : 1;
      this.itemsPerPage = query.itemsperpage ? Number(query.itemsperpage) : 50;
      this.retrieveLogs();
    }
  },
  methods: {
    // loops over all of the values in the route query object and checks to see if its empty
    isQueryParamsEmpty(obj) {
      let bool = true;
      // set an array of object values
      const objectValues = Object.values(obj);
      // loop over object values and make sure none of them are null
      for (let i = 0; i < objectValues.length; i++) {
        if (objectValues[i] !== null || objectValues[i] !== '') {
          bool = false;
          break;
        }
      }
      return bool;
    },
    clearSearch() {
      this.dateStart = null;
      this.dateEnd = null;
      this.providerSearchModel = null;
      this.studentSearchModel = null;
      this.locationSearchModel = null;
    },
    clearProviderAutoComplete() {
      if (!this.providerSearchModel) {
        this.providerSearchArray = [];
      }
    },
    clearStudentAutoComplete() {
      if (!this.studentSearchModel) {
        this.studentSearchArray = [];
      }
    },
    clearLocationAutoComplete() {
      if (!this.locationSearchModel) {
        this.locationSearchArray = [];
      }
    },
    serviceDateStartChanged(val) {
      this.dateStart = utilityFunctions.formatDate(val);
    },
    serviceEndDateChanged(val) {
      this.dateEnd = utilityFunctions.formatDate(val);
    },
    formatDateForSearch(date) {
      if (!date) return '';
      return moment(date, 'MM-DD-YYYY').format('YYYY-MM-DD');
    },
    retrieveLogs() {
      let url = '/api/nursing_service_logs';
      let from = '';
      let to = '';
      let provideruserid = '';
      let studentid = '';
      let locationid = '';
      let pagenumber = '';
      let itemsperpage = '';
      let str = '?';
      let paramCount = 0;

      if (this.dateStart) {
        paramCount += 1;
        from = this.formatDateForSearch(this.dateStart);
        str += `from=${from}`;
      }

      if (this.dateEnd) {
        if (paramCount > 0) str += '&';
        paramCount += 1;
        to = this.formatDateForSearch(this.dateEnd);
        str += `to=${to}`;
      }

      if (this.providerSearchModel) {
        // set the object in local storage to use when navigating back to the page
        localStorage.setItem('provider-search-object', JSON.stringify(this.providerSearchModel));
        if (paramCount > 0) str += '&';
        paramCount += 1;
        provideruserid = this.providerSearchModel.userId;
        str += `provideruserid=${provideruserid}`;
      } else {
        // parameter wasn't used make sure nothing exists in local storage
        localStorage.removeItem('provider-search-object');
      }

      if (this.studentSearchModel) {
        // set the object in local storage to use when navigating back to the page
        localStorage.setItem('student-search-object', JSON.stringify(this.studentSearchModel));
        if (paramCount > 0) str += '&';
        paramCount += 1;
        studentid = this.studentSearchModel.studentId;
        str += `studentid=${studentid}`;
      } else {
        // parameter wasn't used make sure nothing exists in local storage
        localStorage.removeItem('student-search-object');
      }

      if (this.locationSearchModel) {
        // set the object in local storage to use when navigating back to the page
        localStorage.setItem('location-search-object', JSON.stringify(this.locationSearchModel));
        if (paramCount > 0) str += '&';
        paramCount += 1;
        locationid = this.locationSearchModel.locationId
        str += `locationid=${locationid}`;
      } else {
        // parameter wasn't used make sure nothing exists in local storage
        localStorage.removeItem('location-search-object');
      }

      if (this.pageNumber) {
        if (paramCount > 0) str += '&';
        paramCount += 1;
        pagenumber = this.pageNumber;
        str += `pagenumber=${pagenumber}`;
      }

      if (this.itemsPerPage) {
        if (paramCount > 0) str += '&';
        itemsperpage = this.itemsPerPage;
        str += `itemsperpage=${itemsperpage}`;
      }

      // set route params
      this.$router.push({
        path: this.$route.path,
        query: {
          from,
          to,
          provideruserid,
          studentid,
          locationid,
          pagenumber,
          itemsperpage
        }
      });
      url += str;
      this.executeSearch(url);
    },
    executeSearch(url) {
      this.errorMsg = null;
      this.showLoading = true;
      this.serviceLogsArray = [];
      api.get(url)
        .then((res) => {
          const data = res.data.data;
          this.totalCount = data.totalCount;
          this.totalPages = data.totalPages;
          if (!data.items.length) throw new Error('No Service Logs found.')
          this.serviceLogsArray = data.items;
        })
        .catch((error) => {
          this.errorMsg = error.message;
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
    onRetrieveLogsClicked() {
      // reset items per page
      this.itemsPerPage = 50;
      // reset pageNumber
      this.pageNumber = 1;
      this.retrieveLogs();
    },
    deleteServiceLog() {
      // refresh the data
      this.retrieveLogs();
    }
  },
  created() {
    this.provider = this.selectedProvider;
    Promise.all([
      api.get('/api/schools'),
      api.get('/api/nursing_service_logs/providers')
    ])
      .then((promises) => {
        this.schoolArray = promises[0].data.data;
        this.providersArray = promises[1].data.data;
      })
      .catch((error) => {
        this.errorMsg = error.message;
      });
  },
  watch: {
    // fires the api call to get service location list
    locationSearchInput() {
      // show loading
      this.locationSearchLoading = true;
      // clear timeout if function is called before setTimeout fires
      clearTimeout(this.timeout);
      // make sure the user types something before firing request
      if (this.locationSearchInput) {
        // fire the request after a delay
        this.timeout = setTimeout(() => {
          api.get((`/api/service_locations?search=${this.locationSearchInput}`))
            .then((res) => {
              this.locationSearchArray = res.data.data;
            })
            .catch((error) => {
              this.locationSearchError = error.message;
            })
            .finally(() => {
              this.locationSearchLoading = false;
            });
        }, 300);
      } else {
        this.locationSearchLoading = false;
      }
    },
    // fires the api call to get service location list
    studentSearchInput() {
      // show loading
      this.studentSearchLoading = true;
      // clear timeout if function is called before setTimeout fires
      clearTimeout(this.timeout);
      // make sure the user types something before firing request
      if (this.studentSearchInput) {
        // fire the request after a delay
        this.timeout = setTimeout(() => {
          api.get((`/api/nursing_service_logs/students?search=${this.studentSearchInput}`))
            .then((res) => {
              this.studentSearchArray = res.data.data;
            })
            .catch((error) => {
              this.studentSearchError = error.message;
            })
            .finally(() => {
              this.studentSearchLoading = false;
            });
        }, 300);
      } else {
        this.studentSearchLoading = false;
      }
    },
    providerSearchInput() {
      // show loading
      this.providerSearchLoading = true;
      // clear timeout if function is called before setTimeout fires
      clearTimeout(this.timeout);
      // make sure the user types something before firing request
      if (this.providerSearchInput) {
        // fire the request after a delay
        this.timeout = setTimeout(() => {
          api.get((`/api/nursing_service_logs/providers?search=${this.providerSearchInput}`))
            .then((res) => {
              this.providerSearchArray = res.data.data;
            })
            .catch((error) => {
              this.providerSearchError = error.message;
            })
            .finally(() => {
              // stop loading
              this.providerSearchLoading = false;
            });
        }, 300);
      } else {
        this.providerSearchLoading = false;
      }
    },
    providerSearchModel(newVal, oldVal) {
      if (!newVal && oldVal) this.providerSearchArray = [];
    },
    studentSearchModel(newVal, oldVal) {
      if (!newVal && oldVal) this.studentSearchArray = [];
    },
    locationSearchModel(newVal, oldVal) {
      if (!newVal && oldVal) this.locationSearchArray = [];
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/service-log/search/service-log-search.js